export default __webpack_public_path__ + "static/media/163.5184cecd.svg";